module.exports = __webpack_public_path__ + "img/huk1.c502136d.png";